export default __webpack_public_path__ + "static/media/atritec-icon.233788e9.svg";